export default __webpack_public_path__ + "static/media/header-logo-notext.d0a6061e.svg";